exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "ul.nav.nav-tabs li {\n  cursor: pointer; }\n\nul.nav.nav-tabs li.active {\n  pointer-events: none; }\n\nul.nav.nav-pills li {\n  cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/settings/settings.scss
// module id = 1094
// module chunks = 1